import $ from 'jquery';
import responsiveBg from "./responsiveBg";
import lazyLoad from "./lazyLoad";

export default () => {
    const slider = $('.js-slider-content');
    const tabs = $('.js-slider-tabs');

    tabs.slick({
        asNavFor: '.js-slider-content',
        centerMode: true,
        centerPadding: '33%',
        focusOnSelect: true,
        arrows: false,
    });

    slider.slick({
        asNavFor: '.js-slider-tabs',
        slidesToShow: 1,
        focusOnSelect: true,
        mobileFirst: true,
        responsive: [
            {
                breakpoint: 899,
                settings: {
                    centerMode: true,
                    centerPadding: '20%',
                    arrows: false
                }
            }, {
                breakpoint: 1439,
                settings: {
                    centerMode: true,
                    centerPadding: '29%',
                    arrows: false
                }
            }
        ]
    });

    $(window).on('load', function() {
        lazyLoad('.js-slider-content .lazy');

        responsiveBg('.js-slider-content .js-responsive-bg');
    });
}



// WEBPACK FOOTER //
// ../src/scripts/modules/slider.js